const headers = {
  "Content-Type": "application/json",
  Authorization: "Token baded88242cae250cd928ba7ddde6e94266e68a6"
};

export const apiRegister = payload =>
  fetch("http://leadcollector.somas.org.br/api/leads", {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload)
  }).then((response) => {
    if (response.status === 201) {
      return response.json();
    } else {
      throw response.json();
    }
  });
